import React, { Component } from 'react';
import styles from '../components/textBlock.module.css';


class TextBlock extends Component {
    render()
    {
      const { textLines } = this.props;

      return (
        <div className={styles.text_block}> 
          {textLines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      );
    }
  }
  
  export default TextBlock;

 // className={styles.p}